<template>
  <nav class="menu-container">

    <RouterLink
      :exact="item.exact"
      v-for="item in items"
      :key="item.link"
      :to="{ name: item.name }"
      active-class="selected"
      exact-active-class=""
    >
      <div class="icon">
        <Icon :type="item.icon" />
      </div>
      <span>{{ item.title }}</span>
    </RouterLink>
    梅林关站<br>
站点介绍<br>
梅林关站位于梅观路东侧、丰泽湖山庄西侧树林内，沿梅观路方向呈南北向布置。车站设置有5个出入口，先开通A、B出入口（3个预留出入口C、D、E），其中A出入口为主要紧急出入口, B出入口为备用紧急出入口,B出入口为下行松岗方向公交接驳出入口,A出入口为上行科学馆方向公交接驳出入口。B出入口设置垂直电梯，A出入口站厅通道处设置公共卫生间（含第三卫生间）。<br><br>
运营时刻表(工作日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
科学馆	06:14	23:57	6号线	3分24秒	6分20秒<br>
松岗	06:00	23:14	6号线	3分24秒	6分20秒<br><br>
运营时刻表(休息日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
科学馆	06:12	23:57	6号线	4分45秒	6分钟<br>
松岗	06:00	23:14	6号线	4分45秒	6分钟<br><br>
运营时刻表(节假日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
科学馆	06:12	00:57	6号线	4分45秒	6分钟<br>
松岗	06:00	00:14	6号线	4分45秒	6分钟<br><br>
<br>
站点出口信息<br><br>
A出入口:<br>
梅观路（南）、梅林海关<br><br>
B出入口:<br>
梅观路（北）、民乐村、丰泽湖山庄、丹堤实验学校、民乐小学<br><br>
公交换乘信息<br><br>
A出入口:<br>
公交站名： 丰泽湖山庄总站<br>
M312路,7路,34路<br><br>
B出入口:<br>
公交站名： 民乐地铁站<br>
M437、M122、高快巴士3路B出入口<br><br>
B出入口:<br>
公交站名： 民乐地铁站2<br>
M391、M201、60路<br><br>
B出入口:<br>
公交站名： 民乐地铁站3<br>
M488、M448、M447、高峰专线37路、324路、334路<br><br>
B出入口:<br>
公交站名： 民乐地铁站4<br>
M152、M383、75路、313路、333路、393路、391路、E4<br><br>
B出入口:<br>
公交站名： 民乐地铁站5<br>
M339、328路<br><br>
B出入口:<br>
公交站名： 民乐地铁站北公交场站<br>
M263、M577、612路、620路、高快巴士17路<br><br>
B出入口:<br>
公交站名： 新彩隧道口<br>
M459、M347、M262、M223、M207、115路、高峰专线123路<br>
</nav>
</template>

<script>
// import Icon from "@/components/Icon";
export default {
  components: {
    // Icon,
  },
  data() {
    return {
      items: [
        {
          name: "liuhaoxian",
          title: "6号线",
          // icon: "chat",
          exact: true,
        },
      ],
    };
  },
};
</script>

<style scoped lang="less">
@import "~@/styles/var.less";
.menu-container {
  color: @words;
  margin: 24px 0;
  a {
    &.selected {
      background: darken(@words, 3%);
    }
    padding: 0 50px;
    display: block;
    display: flex;
    align-items: center;
    height: 45px;
    // .icon {
    //   width: 24px;
    // }
    &:hover {
      color: rgb(50, 95, 227);
    }
  }
}
</style>